import { React, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  selfserviceUseraction,
  selfserviceUseractionadd,
} from "../../redux/actions";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const UserAction = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedlocation, setSelectedLocation] = useState("");
  const [user_action, setUseraction] = useState([]);
  const [error, setError] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      if (id !== "add") {
        try {
          const data = await selfserviceUseraction(id);
          setUseraction(data || []); // Ensure orders exist
        } catch (err) {
          setError(err.message);
        }
      }
    };
    fetchOrders();
  }, [id]);

  const user_location = useSelector(
    (state) => state?.user_data?.user_data?.locations
  );

  useEffect(() => {
    if (user_location && user_location.length > 0) {
      setSelectedLocation(String(user_location[0].id)); // Set default to first location
    }
  }, [user_location]);

  const user_add = async () => {
    if (!name.trim() || !email.trim()) {
      toast.error("Fill the required fields!");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      toast.error("Invalid email address!");
      return;
    }
    const formData = {
      name: name,
      email: email,
      role: selectedOption,
      location_id: selectedlocation,
    };

    if (id === "add") {
      try {
        const url = "new";
        const data = await selfserviceUseractionadd(url, formData); // ✅ Now await works
        if (data && data?.message) {
          toast.error(data?.message);
        } else if (data === "OK") {
          toast.success("User created successfully");
          setTimeout(() => {
            if (data === "OK") {
              navigate("/self-service/users/");
            }
          }, 2000);
        } else if (data) {
          toast.error(data);
        }
      } catch (err) {
        setError(err.message);
      }
    }
  };

  const user_block = async () => {
    const formData = {
      user_id: { id },
    };
    try {
      const url = "block";
      const data = await selfserviceUseractionadd(url, formData); // ✅ Now await works
      if (data && data?.message) {
        toast.error(data?.message);
      } else if (data === "OK") {
        toast.success("User blocked successfully");
        setTimeout(() => {
          if (data === "OK") {
            navigate("/self-service/users/");
          }
        }, 2000);
      } else if (data) {
        toast.error(data);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const user_invite = async () => {
    const formData = {
      user_id: { id },
    };

    try {
      const url = "resend-invite";
      const data = await selfserviceUseractionadd(url, formData); // ✅ Now await works

      if (data && data?.message) {
        toast.error(data?.message);
      } else if (data === "OK") {
        toast.success("Invite sent successfully");
        setTimeout(() => {
          if (data === "OK") {
            navigate("/self-service/users/");
          }
        }, 2000);
      } else if (data) {
        toast.error(data);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const user_save = async () => {
    const formData = {
      user_id: { id },
      role: selectedOption,
      location_id: selectedlocation,
    };

    try {
      const url = "update";
      const data = await selfserviceUseractionadd(url, formData); // ✅ Now await works
      if (data && data?.message) {
        toast.error(data?.message);
      } else if (data === "OK") {
        toast.success("Updated successfully");
        setTimeout(() => {
          if (data === "OK") {
            navigate("/self-service/users/");
          }
        }, 2000);
      } else if (data) {
        toast.error(data);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    if (user_action) {
      const active = user_action?.page?.data?.user?.is_active;
      const admin = user_action?.page?.data?.user?.is_admin;
      const power = user_action?.page?.data?.user?.is_poweruser;

      if (active && admin) {
        setSelectedOption("admin");
      } else if (active && power) {
        setSelectedOption("poweruser");
      } else {
        setSelectedOption("local");
      }
    }
  }, [user_action]); // Runs only when `user_action` changes

  return (
    <form method="post">
      <div className="page-container">
        {/* Header */}
        <section className="hot-deals pt-20">
          <div className="container container-lg">
            <div className="section-heading">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                {/* Left Section: Name and Extra Button */}
                <div className="d-flex align-items-center gap-12">
                  {id === "add" ? (
                    <h2 className="mb-0 text-blue">Add new user</h2>
                  ) : (
                    <>
                      <h2 className="mb-0 text-blue">
                        {user_action?.page?.data?.user?.name}&nbsp;&nbsp;
                      </h2>
                      {user_action?.page?.data?.user?.is_active === false && (
                        <button className="btn text-gray-500 bg-light-grey">
                          Blocked
                        </button>
                      )}

                      {user_action?.page?.data?.user?.is_active === true &&
                        user_action?.page?.data?.user?.email_confirmed ===
                          true && (
                          <button className="btn bg-main-product-50 hover-bg-main-product-50 hover-text-white text-nowrap">
                            Active
                          </button>
                        )}

                      {user_action?.page?.data?.user?.is_active === true &&
                        user_action?.page?.data?.user?.email_confirmed ===
                          false && (
                          <button className="btn pending_btn">Pending</button>
                        )}
                    </>
                  )}
                </div>

                {/* Right Section: Close Button */}
                <button
                  className="btn bg-main-product-50 hover-bg-main-product-50 hover-text-white text-nowrap"
                  type="button"
                  onClick={() => navigate("/self-service/users/")}
                  style={{
                    minWidth: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  X
                </button>
              </div>
            </div>
          </div>

          {/* Scrollable Body */}
          <div className="scrollable-body">
            <div className="container container-lg">
              <div className="center row gy-4">
                <div className="col-sm-6">
                  <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                    <div className="py-xl-4">
                      <div className="d-flex flex-column gap-3">
                        <div className="d-flex align-items-center gap-2">
                          <label
                            htmlFor="city"
                            className="font-heading-two text-gray-900 fw-semibold mb-0 lable-font"
                            style={{ minWidth: "120px" }}
                          >
                            Name *
                          </label>
                          {id === "add" ? (
                            <input
                              type="text"
                              className="common-input px-16 flex-grow-1 input-font"
                              id="name"
                              name="name"
                              placeholder="name"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                            />
                          ) : (
                            <p>{user_action?.page?.data?.user?.name}</p> // Show ID inside <p> when it's not "add"
                          )}
                        </div>
                        <hr />
                        <div className="d-flex align-items-center gap-2">
                          <label
                            htmlFor="street"
                            className="font-heading-two text-gray-900 fw-semibold mb-0 lable-font"
                            style={{ minWidth: "120px" }}
                          >
                            E-mail *
                          </label>
                          {id === "add" ? (
                            <input
                              type="email"
                              className="common-input px-16 flex-grow-1 input-font"
                              id="email"
                              name="email"
                              placeholder="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          ) : (
                            <p>{user_action?.page?.data?.user?.email}</p> // Show ID inside <p> when it's not "add"
                          )}
                        </div>
                        <br />
                        <h3 className="center text-blue">User Role</h3>
                        <hr />
                        <div className="d-flex align-items-center gap-2">
                          {/* Email Notification */}
                          <div className="common-check common-radio mb-0">
                            <input
                              className="input-font form-check-input input-font"
                              type="radio"
                              name="notification_via"
                              id="localNotification"
                              value="local"
                              checked={selectedOption === "local"}
                              disabled={
                                user_action?.page?.data?.user?.is_active ===
                                false
                              }
                              onChange={(e) =>
                                setSelectedOption(e.target.value)
                              }
                            />
                            <label
                              className="lable-font form-check-label "
                              htmlFor="localNotification"
                            >
                              Local user can do stuff limited to their assigned
                              location.
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="d-flex align-items-center gap-2">
                          {/* SMS Notification */}
                          <div className="common-check common-radio mb-0">
                            <input
                              className="input-font form-check-input"
                              type="radio"
                              name="notification_via"
                              id="poweruserNotification"
                              value="poweruser"
                              checked={selectedOption === "poweruser"}
                              onChange={(e) => {
                                setSelectedOption(e.target.value);
                                setSelectedLocation("");
                              }}
                              disabled={
                                user_action?.page?.data?.user?.is_active ===
                                false
                              }
                            />
                            <label
                              className="lable-font form-check-label"
                              htmlFor="poweruserNotification"
                            >
                              Power-user can do everything in every location.
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="d-flex align-items-center gap-2">
                          {/* Push Notification */}
                          <div className="common-check common-radio mb-0">
                            <input
                              className="input-font form-check-input"
                              type="radio"
                              name="notification_via"
                              id="adminNotification"
                              value="admin"
                              checked={selectedOption === "admin"}
                              onChange={(e) => {
                                setSelectedOption(e.target.value);
                                setSelectedLocation("");
                              }}
                              disabled={
                                user_action?.page?.data?.user?.is_active ===
                                false
                              }
                            />
                            <label
                              className="lable-font form-check-label "
                              htmlFor="adminNotification"
                            >
                              Company admin is a power-user who has also user
                              management rights.
                            </label>
                          </div>
                        </div>
                        <hr></hr>
                        {/* Show Select Box only if "admin" is selected */}
                        {selectedOption === "local" ? (
                          <div className="d-flex align-items-center gap-2 flex-grow-1">
                            <label
                              htmlFor="phone"
                              className="font-heading-two text-gray-900 fw-semibold mb-0 lable-font"
                              style={{ minWidth: "120px" }}
                            >
                              Location
                            </label>
                            <select
                              className="common-input input-font"
                              name="country"
                              id="country"
                              value={selectedlocation}
                              onChange={(e) =>
                                setSelectedLocation(e.target.value)
                              }
                            >
                              {user_location && user_location.length > 0 ? (
                                user_location.map((data, index) => (
                                  <option key={index} value={data.id}>
                                    {data?.delivery_address?.city}
                                  </option>
                                ))
                              ) : (
                                <option value="">No locations available</option>
                              )}
                            </select>
                          </div>
                        ) : (
                          <input type="hidden" name="country" value="" />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Fixed Footer */}
          <div className="fixed-footer">
            <button
              className="btn pending_btn"
              type="button"
              onClick={() => navigate("/self-service/users/")}
            >
              Cancel
            </button>
            {id === "add" ? (
              <button
                className="btn bg-main-product-50 hover-bg-main-product-50 hover-text-white text-nowrap mt-2"
                type="button"
                onClick={user_add}
              >
                Invite User
              </button>
            ) : (
              <>
                <div className="d-flex gap-2 mt-2">
                  <button
                    className="btn pending_btn"
                    type="button"
                    onClick={user_block}
                  >
                    Block User
                  </button>
                  {user_action?.page?.data?.user?.is_active === true &&
                  user_action?.page?.data?.user?.email_confirmed === true ? (
                    <button
                      type="button"
                      className="btn bg-main-product-50 hover-bg-main-product-50 hover-text-white text-nowrap"
                      onClick={user_save}
                    >
                      Save user
                    </button>
                  ) : (
                    <button
                      className="btn bg-main-product-50 hover-bg-main-product-50 hover-text-white text-nowrap"
                      type="button"
                      onClick={user_invite}
                    >
                      Resend Invitation
                    </button>
                  )}
                </div>
              </>
            )}
          </div>
        </section>
      </div>
    </form>
  );
};

export default UserAction;
